import React from 'react'

import {
  BrowserRouter,
  Routes,
  Route,
} from 'react-router-dom'

import DashboardLayout from './layouts/DashboardLayout/DashboardLayout'

import Dashboard from './pages/Dashboard/Dashboard'
import CatalogPage from './pages/Catalog/CatalogPage'
import EditProductPage from './pages/Catalog/EditProductPage'
import OrdersPage from './pages/Orders/OrdersPage'
import VouchersPage from './pages/Vouchers/VouchersPage'
import CreateVoucherPage from './pages/Vouchers/CreateVoucherPage'
import CreatePromoCodePage from './pages/Vouchers/CreatePromoCodePage'
import PointsManagementPage from './pages/PointsManagement/PointsManagementPage'
import PaymentConfigPage from './pages/PaymentConfig/PaymentConfigPage'
import OutletSetupPage from './pages/OutletSetup/OutletSetupPage'
import SalesReportPage from './pages/SalesReport/SalesReportPage'
import CustomersPage from './pages/Customers/CustomersPage'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<DashboardLayout />}>
          <Route
            path="/"
            element={<Dashboard />}
          />

          <Route
            path="/catalog"
            element={<CatalogPage />}
          />

          <Route
            path="/products/:id/edit"
            element={<EditProductPage />}
          />

          <Route
            path="/orders"
            element={<OrdersPage />}
          />

          <Route
            path="/vouchers"
            element={<VouchersPage />}
          />

            <Route
                path="/vouchers/create-reward"
                element={<CreateVoucherPage />}
            />

            <Route
                path="/vouchers/create-promo"
                element={<CreatePromoCodePage />}
            />

          <Route
            path="/points-management"
            element={<PointsManagementPage />}
          />

          <Route
            path="/payment-config"
            element={<PaymentConfigPage />}
          />

          <Route
            path="/outlet-setup"
            element={<OutletSetupPage />}
          />

          <Route
            path="/sales-reporting"
            element={<SalesReportPage />}
          />
          <Route
            path="/customers"
            element={<CustomersPage />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App